import React from "react";
import { CommonButton } from "../ui/CommonButton";

export const ToAccountOpenCard = ({
  icon,
  title,
  buttontext,
  contentWidth,
  buttonSize,
  onClick,
  onOpenModal,
  isSelected,description
}) => {
  const handleCardClick = () => {
    onClick && onClick();
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // prevent triggering card click
    onOpenModal && onOpenModal();
  };

  return (
    <div
      onClick={handleCardClick}
      className={`
        relative cursor-pointer rounded-2xl transition-transform duration-200
        flex flex-col items-center justify-between
        bg-white shadow-sm border
        ${isSelected ? "scale-[1.02] border-blue-500 shadow-md" : "hover:shadow-md"}
        flex-1 min-w-[260px] max-w-full
      `}
      style={{ minHeight: 220,padding:5}}
    >
      {/* Icon */}
      <div className="mt-6 flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-blue-100 to-blue-50 text-blue-600 text-3xl shadow-inner">
        {icon}
      </div>

      {/* Title */}
      <div className="mt-4 text-center">
        <div className="text-gray-800 font-semibold text-lg">{title}</div>
         <p className="mt-2 text-sm text-gray-500">
           {description}
        </p>
      </div>

      {/* Button */}
      <div
        className={`mt-6 ${contentWidth || "w-3/4"} flex justify-center`}
        onClick={handleButtonClick}
      >
        <CommonButton text={buttontext} size={buttonSize} />
      </div>

      {/* Selected badge */}
      {isSelected && (
        <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs px-3 py-1 rounded-full shadow">
          Selected
        </div>
      )}
    </div>
  );
};
